export default __webpack_public_path__ + "static/media/hubilo.190ee475.svg";